module.exports = __webpack_public_path__ + "img/Leandro Miguel Quizon.e7e1e091.jpg";